import type { InputTypeMap } from "@mui/base/Input";
import { Input } from "@mui/base/Input";
import { forwardRef } from "react";

import { StyledInput as input, Root as root } from "scmp-app/components/common/base-input/styles";

export type Props = InputTypeMap["props"];

export const BaseInput = forwardRef<HTMLInputElement, Props>(({ slots, ...props }, reference) => (
  <Input slots={{ input, root, ...slots }} {...props} ref={reference} />
));

BaseInput.displayName = "BaseInput";
